import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const Graph8 = () => {
  const [donnees, setDonnees] = useState([]);

  useEffect(() => {
    fetch('/montant_echue_client.json')
      .then((res) => res.json())
      .then((data) => {
        const donneesFiltrees = data.filter(
          (ligne) => ligne.Client?.toUpperCase() !== 'TOTAL'
        );

        const donneesTriees = donneesFiltrees.sort(
          (a, b) => (b['Montant échue'] || 0) - (a['Montant échue'] || 0)
        );

        setDonnees(donneesTriees);
      })
      .catch((err) => console.error('Erreur chargement JSON :', err));
  }, []);

  const labels = donnees.map((ligne) => ligne.Client);
  const valeurs = donnees.map((ligne) => ligne['Montant échue'] || 0);

  // Calcul des couleurs du dégradé du rouge clair au rouge foncé
  const min = Math.min(...valeurs);
  const max = Math.max(...valeurs);

  const getRedGradient = (val) => {
    const ratio = (val - min) / (max - min || 1); // Évite division par 0
    const r = 255;
    const g = Math.round(200 * (1 - ratio)); // 200 → 0
    const b = Math.round(200 * (1 - ratio)); // 200 → 0
    return `rgba(${r}, ${g}, ${b}, 0.7)`; // alpha à 0.7 pour un peu de transparence
  };

  const backgroundColors = valeurs.map(getRedGradient);
  const borderColors = valeurs.map(() => 'rgba(255, 0, 0, 1)'); // Rouge foncé pour toutes les bordures

  const data = {
    labels,
    datasets: [
      {
        label: 'Montant échue (€)',
        data: valeurs,
        backgroundColor: backgroundColors,
        borderColor: borderColors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => {
            const val = context.parsed.y ?? context.parsed;
            return typeof val === 'number'
              ? val.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })
              : val;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (val) => `${val.toLocaleString('fr-FR')} €`,
        },
      },
    },
  };

  return (
    <div>
      <Bar data={data} options={options} height={500} width={600} />
    </div>
  );
};

export default Graph8;
